import React from "react";
import { Eye, Layers3, Sparkles } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const principles = [
  { number: "01", title: "Information at a glance", text: "The right signal should be present before you go looking for it.", icon: Eye },
  { number: "02", title: "Designed around context", text: "A desk and a driveway ask different questions. Our products respect that.", icon: Layers3 },
  { number: "03", title: "Connected without clutter", text: "Useful technology can stay quietly in the background until it matters.", icon: Sparkles },
];

export default function CompanyPrinciplesSection() {
  const { t } = useLanguage();
  const copy = t("home.principles");

  return (
    <section id="principles" className="relative border-y border-brand-100 bg-white py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="grid gap-10 lg:grid-cols-[.72fr_1.28fr] lg:items-end">
          <div><p className="home-eyebrow">{copy.eyebrow}</p><h2 className="home-title mt-3 max-w-lg">{copy.title}</h2></div>
          <p className="max-w-xl text-base leading-7 text-slate-600 lg:justify-self-end">{copy.body}</p>
        </div>
        <div className="mt-12 grid gap-4 md:grid-cols-3">
          {principles.map(({ number, icon: Icon }, index) => (
            <article key={number} className="group relative border-t border-brand-200 pt-5 transition hover:border-brand-700">
              <div className="flex items-start justify-between gap-4"><span className="font-display text-sm font-bold text-brand-700">{number}</span><Icon className="h-5 w-5 text-brand-600 transition group-hover:scale-110" aria-hidden="true" /></div>
              <h3 className="mt-8 max-w-[14rem] font-display text-xl font-bold leading-tight tracking-[-.04em] text-slate-950">{copy.items[index][0]}</h3>
              <p className="mt-3 max-w-xs text-sm leading-6 text-slate-600">{copy.items[index][1]}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
